import i18n from '@/utils/i18n';
import React from 'react';
import { ArrowDirection } from '@sales-portal/domain/pricing/screens/management/types';
import { Delta, DeltaDirection, MetricCard } from '@usepepper/sprout-kit-ui';
import { Pressable } from 'react-native';
import { PricingHubBlockMetric } from '@sales-portal/domain/pricing/screens/overview/types';

interface Props {
  hasError?: boolean;
  isLoading?: boolean;
  metric: PricingHubBlockMetric;
  onPress: () => void;
  title: string;
  // Folds the caption into the value — "12 to review". Off for cards whose
  // label already names the unit.
  withCaption?: boolean;
}

const DELTA_DIRECTION_BY_ARROW: Record<ArrowDirection, DeltaDirection> = {
  [ArrowDirection.Down]: 'down',
  [ArrowDirection.Up]: 'up',
};

// No direction means no arrow — Delta's `flat` renders the text alone.
const toDeltaDirection = (direction?: ArrowDirection): DeltaDirection =>
  direction ? DELTA_DIRECTION_BY_ARROW[direction] : 'flat';

export const PricingOverviewBlockCard: React.FC<Props> = ({
  hasError = false,
  isLoading = false,
  metric,
  onPress,
  title,
  withCaption = false,
}) => {
  return (
    <Pressable
      accessibilityLabel={title}
      disabled={isLoading}
      onPress={onPress}
    >
      <MetricCard
        label={title}
        state={hasError ? 'error' : isLoading ? 'loading' : 'default'}
        value={
          hasError
            ? i18n.t('pricing.overview.block_error')
            : withCaption
              ? `${metric.value} ${metric.caption}`
              : metric.value
        }
      >
        {hasError ? (
          <Delta direction="flat" value="--" />
        ) : isLoading ? (
          <MetricCard.FooterSkeleton />
        ) : (
          <Delta
            arrowPlacement="left"
            direction={toDeltaDirection(metric.footerDirection)}
            value={metric.footer}
          />
        )}
      </MetricCard>
    </Pressable>
  );
};
